export default __webpack_public_path__ + "static/media/000_intro_part2.last.0f63f9af.png";